<template>
	<div>
		<div class="list-btn">
			
			<Button type="primary" @click="add">新增</Button>
			<Button type="primary" @click="shangji" v-if="query.parentId!=0">返回上级</Button>
			
		</div>
		<div class="btn">
			<div class="jiams tj" style="display: flex;">
				<Select v-model="query.operId" style="width:300px" @on-change="onchangeSousuo1" placeholder="请选择运营商">
				        <Option v-for="item in opers" :value="item.id" :key="item.id">{{ item.id }}-{{item.companyName}}</Option>
				</Select>
				<div class="jiams tj" v-if="query.operId!=null" style="display: flex;">
					<Select v-model="oper.commissionWay" style="width:300px"  placeholder="请选择抽成方式">
					        <Option value="0">订单金额</Option>
							<Option value="1">一级分类</Option>
							<Option value="2">二级分类</Option>
							<Option value="3">三级分类</Option>
					</Select>
					<Input type="number" v-if="oper.commissionWay=='0'" style="width: 300px" v-model="oper.commissionRake" placeholder="请输入分成比例">
						<span slot="append" >%</span>
					</Input>
					<Button type="primary" @click="queding" style="margin-left: 20px;">确定</Button>
				</div>
			</div>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				 <Button type="primary" size="small" style="margin-right: 5px" @click="update(row)">修改</Button>
				 <Button type="primary" size="small" style="margin-right: 5px" @click="xiaji(row.id)"  v-show="row.level!=2">下级分类</Button>
				<Button  size="small" style="margin-right: 5px" class="delete" @click="remove(row.id)" v-show="row.state==false" >启用</Button>
				<Button  size="small" style="margin-right: 5px" class="error" @click="remove(row.id)" v-show="row.state==true">禁用</Button>
				 
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				dqLevel:0,
				showPage:true,
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '排序',
						key: 'rankNumber'
					},
					{
						title: '描述',
						key: 'typeExplain'
					},
					
					{
						title: '抽成比例',
						key: 'rake',
						render: (h, params) => {
							return h("div",params.row.rake/100+"%")
						}
					},
					{
						title: '状态',
						key: 'state',
						render: (h, params) => {
							if(params.row.state==true){
								return h("div","启用")
							}else{
								return h("div","禁用")
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
				data6: [
				],
				sj:[0],
				opers:[],
				oper:{
					commissionWay:'0',
					commissionRake:0,
					operId:''
				},
				query:{
					page:0,
					size:10,
					level:0,
					parentId:0,
					operId:null
				}

			}
		},
		methods: {
			queding(){
				let _this=this
				_this.oper.operId=_this.query.operId
				if(_this.oper.commissionRake<0 || _this.oper.commissionRake>100){
					
						_this.$Message.error('请输入正确的抽成比例！！！');
					return ;
				}
				
				let aaa={
					commissionWay:_this.oper.commissionWay,
					commissionRake:_this.oper.commissionRake*100,
					operId:_this.oper.operId
				}
				if(aaa.commissionWay!='0'){
					aaa.commissionRake='0'
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/update/jm/rake',
				    data: aaa,
					_this: _this,
					success: function(data) {
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			onchangeSousuo1(a){
				console.log(a)
				
				this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
				for (var i = 0; i < this.opers.length; i++) {
					let aa=this.opers[i]
					if(aa.id==a){
						this.oper.commissionWay=aa.commissionWay+''
						this.oper.commissionRake=aa.commissionRake/100+''
					}
					
				}
			},
			queryOper(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/page',
				    data: {
						page:0,
						size:50,
					},
					_this: _this,
					success: function(data) {
						_this.opers = data.opers.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			shangji(){
			    console.log(this.sj[this.sj.length-1])
				this.query.parentId=this.sj[this.sj.length-1]
				this.sj.splice(this.sj.indexOf(this.sj[this.sj.length-1]),1);
				this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				
				this.dqLevel--
				this.ajaxPage()
			},
			update(a) { //修改
				this.$router.push({
					name: 'jm/finance/type/update',
					query:{
						id:a.id,
						dqLevel:a.level,
						operId:this.query.operId
					}
				})
			},
			xiaji(id){
				// this.$router.push({
				// 	name: 'jm/finance/type/list2',
				// 	query:{
				// 		id:id
				// 	}
				// })
				this.sj.push(this.query.parentId)
				this.query.parentId=id
				this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.dqLevel++
				this.ajaxPage()
			},
			remove(id) { 
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/update/state',
				    data: {id:id},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			add() {
				let _this=this
				this.$router.push({
					name: 'jm/finance/type/add',
					query:{
						parentId:this.query.parentId,
						dqLevel:_this.dqLevel
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/jm/caiwu',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.ajaxPage()
			this.queryOper()
		},
		activated(){
			this.ajaxPage();
		},
		
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
		display: flex;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/finance/type/list.vue